import React, { useState } from 'react';
import { Row, Label } from "reactstrap"
import { MultiSelect } from "react-multi-select-component";

import "../../assets/scss/custom/components/_multidropdown.scss"





export default function MultipleSelectCheckmarks({
  selected,
  setSelected,
  options,
  rowClass,
  labelHide,
  iconShow,
  labelText,
  disabled
}) {


  return (
    <div>

      <Row className={rowClass}>
        {labelHide ? "" : <Label
          htmlFor="example-text-input"
          className="col-md-3 col-form-label-sm"
        >
          {labelText}&nbsp;
          {iconShow ? (<i className={icon} style={{ fontSize: '12px', color: color }}></i>) : null}
        </Label>}
        <div className="col-md-9">
          <MultiSelect
            options={options}
            value={selected}
            onChange={setSelected}
            labelledBy="Select"
            disabled={disabled}
            closeOnChangedValue={false}
          />
        </div>
        <p></p>
      </Row>

    </div>
  );

}

